var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHamburgerMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hamburger",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 478.3 449.5",
    style: {
      enableBackground: "new 0 0 478.3 449.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#010101;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,13.8h432.1c11.9,0,21.6,13.4,21.6,29.9l0,0c0,16.5-9.7,29.9-21.6,29.9H23.1c-11.9,0-21.6-13.4-21.6-29.9 l0,0C1.5,27.2,11.2,13.8,23.1,13.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,375.9h432.1c11.9,0,21.6,13.4,21.6,29.9l0,0c0,16.5-9.7,29.9-21.6,29.9H23.1 c-11.9,0-21.6-13.4-21.6-29.9l0,0C1.5,389.3,11.2,375.9,23.1,375.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M23.1,194.9h432.1c11.9,0,21.6,13.4,21.6,29.9l0,0c0,16.5-9.7,29.9-21.6,29.9H23.1 c-11.9,0-21.6-13.4-21.6-29.9l0,0C1.5,208.3,11.2,194.9,23.1,194.9z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburger-menu.b65c5c66bb4e176a743720c982c36b9d.svg";
export { ForwardRef as ReactComponent };